import {
    createContext,
    useContext,
    useMemo,
    useReducer
} from 'react';
import { deliveryActionConstants } from '@/Store/Actions/delivery_action';

// Create a context to hold the state
export const DeliveryContext = createContext();

// Define the initial state
const initialState = {
    queryInformation: null,
    cachedPages: []
};

// Define the reducer function to handle state transitions
const reducer = (state, action) => {
    switch (action.type) {
        case deliveryActionConstants.SAVE_QUERY_INFORMATION:
            return {
                ...state,
                queryInformation: action?.queryInformation
            };
        case deliveryActionConstants.CACHE_PAGE_DATA:
            return {
                ...state,
                cachedPages: [
                    ...state?.cachedPages,
                    {
                        key: action?.key,
                        pageData: action?.pageData
                    }
                ]
            };
        default:
            throw new Error();
    }
};

export const DeliveryProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const deliveryState = useMemo(() => {
        return { ...(state || {}) };
    }, [state]);

    // In this return value, we passed-in children as the CONSUMER of the PROVIDER
    // This will able children components to access the data inside the context
    return (
        <DeliveryContext.Provider value={{ delivery: deliveryState, dispatch }}>
            {children}
        </DeliveryContext.Provider>
    );
};

export const useDeliveryContext = () => {
    return useContext(DeliveryContext);
};
